import React, { useState } from "react";

import Button from "../../common/Button";
import TextField from "../../common/TextField";
import { askQuestion } from '../../../api/common-api';

const QuestionForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    question: "",
  });

  const handleChange = (e, target) => {
    setFormData({ ...formData, [target]: e.target.value });
  };
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async(e)=> {
    e.preventDefault();
    setError(false);
    setSuccess(false);
    try {
      setLoading(true);
      await askQuestion(formData);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
      setFormData({
        name: "",
        email: "",
        question: "",
      });

    } catch (error) {
      setError(error?.response?.data?.toString() ?? 'An error has occured.');
    }
    finally{
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
    <div className="flex flex-col items-center mx-10">
      <p className="uppercase font-semibold text-sm text-warning text-center mb-8">
        question
      </p>
      <p className="font-semibold md:text-5xl text-4xl text-dark text-center mb-8">
        Still have a question?
      </p>
      <p className="text-xl leading-normal text-dark text-center mb-10 opacity-70">
        Send your question our way and we’ll get back to you within 48 hour!
      </p>
      <div className="w-full flex flex-wrap -mx-3.5">
        <div className="md:w-1/2 w-full px-3.5 mb-[30px]">
          <TextField
            value={formData.name}
            onChange={(e) => {
              handleChange(e, "name");
              if(error.startsWith("Name")) setError("");
            }}
            size="lg"
            placeholder="Your Name*"
          />
        </div>
        <div className="md:w-1/2 w-full px-3.5 mb-[30px]">
          <TextField
            value={formData.email}
            onChange={(e) => {
              handleChange(e, "email");
              if(error.startsWith("Email")) setError("");
            }}
            size="lg"
            placeholder="Your Email*"
          />
        </div>
        <div className="w-full px-3.5 mb-[30px]">
          <TextField
            value={formData.question}
            onChange={(e) => handleChange(e, "question")}
            multiple
            placeholder="Enter your question here*"
          />
        </div>
       
        <div className=" px-3.5 mb-8">        
              <Button disabled={loading} type="submit" color="success">
            {
              loading? 'Submitting...': 'Submit'
            }
          </Button>
        </div>
      </div>
      {error ? <div className="w-full p-2 rounded mb-2 bg-red-200">{error}</div> : undefined }
      {success ? 
        <div className="w-full p-2 rounded mb-2 bg-green-200">
          We have received your question. we’ll get back to you within 48 hours!
        </div> : undefined
      }
    </div>
    </form>
  );
};

export default QuestionForm;
